/**
 * @Description 本地临时菜单
 * @Author cyp
 * @Date 2025/9/30 13:57
 */
export const menuData = [
  {
    name: 'Home',
    path: '/home',
    hidden: false,
    redirect: null,
    component: 'home/index',
    query: null,
    alwaysShow: false,
    meta: {
      title: 'Home',
      icon: 'home',
      noCache: true
    }
  },
  {
    path: '/',
    hidden: false,
    component: 'Layout',
    children: [
      {
        name: 'About',
        path: '/about',
        hidden: false,
        redirect: null,
        component: 'about/index',
        query: null,
        alwaysShow: false,
        page: 'tbbaccess',
        meta: {
          title: 'About',
          icon: 'home',
          noCache: true
        }
      }
    ]
  }
]
